export function setupVariationHandler() {
  const form = document.querySelector(".custom-add-to-cart-form");
  if (!form || !window.productVariations) {
    return;
  }

  const attributeTabs = document.querySelectorAll(".attribute-tab");
  const variationIdInput = form.querySelector('input[name="variation_id"]');
  const quantityInput = form.querySelector('input[name="quantity"]');
  const submitButton = form.querySelector(".custom-add-to-cart-button");
  const priceElement = document.querySelector(".product-price");
  const originalPrice = priceElement?.dataset.basePrice;
  const notifyStockButton = document.getElementById("notify-stock-button"); // Get the notify button

  const getSelectedAttributes = () => {
    const selected = {};
    document.querySelectorAll(".attribute-tabs").forEach((tabGroup) => {
      const activeTab = tabGroup.querySelector(".active");
      if (activeTab) {
        const attributeName = activeTab.dataset.attribute;
        const attributeValue = activeTab.dataset.value;
        selected[attributeName] = attributeValue;
      }
    });
    return selected;
  };

  const findMatchingVariation = (selectedAttributes) => {
    const formattedAttributes = {};
    Object.entries(selectedAttributes).forEach(([name, value]) => {
      const attributeKey = name.startsWith("pa_")
        ? `attribute_${name}`
        : `attribute_pa_${name.toLowerCase()}`;
      formattedAttributes[attributeKey] = value;
      if (!name.startsWith("pa_")) {
        formattedAttributes[`attribute_${name.toLowerCase()}`] = value;
      }
    });

    let match = null;
    for (const variation of window.productVariations) {
      let allAttributesMatch = true;
      for (const [key, value] of Object.entries(formattedAttributes)) {
        const possibleKeys = [
          key,
          key.replace("attribute_pa_", "attribute_"),
          key.replace("attribute_", "attribute_pa_"),
        ];
        let attributeMatched = false;
        for (const possibleKey of possibleKeys) {
          if (
            variation.attributes.hasOwnProperty(possibleKey) &&
            variation.attributes[possibleKey] === value
          ) {
            attributeMatched = true;
            break;
          }
        }
        if (!attributeMatched) {
          allAttributesMatch = false;
          break;
        }
      }
      if (allAttributesMatch) {
        match = variation;
        break;
      }
    }
    return match;
  };

  const updateVariationState = () => {
    const selectedAttributes = getSelectedAttributes();
    const matchingVariation = findMatchingVariation(selectedAttributes);

    if (matchingVariation) {
      variationIdInput.value = matchingVariation.variation_id;
      Object.entries(matchingVariation.attributes).forEach(([name, value]) => {
        const existingInput = form.querySelector(`input[name="${name}"]`);
        if (existingInput) {
          existingInput.remove();
        }
        if (value) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = value;
          form.appendChild(input);
        }
      });

      if (matchingVariation.price_html) {
        priceElement.innerHTML = matchingVariation.price_html;
        const mobilePriceElement = document.querySelector(
          ".mobile-info-strip .product-price"
        );
        if (mobilePriceElement) {
          mobilePriceElement.innerHTML = matchingVariation.price_html;
        }
      }

      if (matchingVariation.max_qty !== undefined) {
        quantityInput.max = matchingVariation.max_qty;
        if (matchingVariation.max_qty > 0) {
          quantityInput.value = Math.min(
            Math.max(1, parseInt(quantityInput.value, 10)),
            matchingVariation.max_qty
          );
        } else {
          quantityInput.value = 1;
        }
      }

      const isPurchasable = matchingVariation.is_purchasable;
      const isInStock = matchingVariation.is_in_stock;
      const stockAvailable = matchingVariation.max_qty > 0;

      if (isPurchasable && isInStock && stockAvailable) {
        submitButton.disabled = false;
        submitButton.textContent = cartVars.texts.addToCart;
        submitButton.classList.remove("out-of-stock");
        if (notifyStockButton) {
          notifyStockButton.classList.add("hide");
          notifyStockButton.dataset.variationId = "";
        }
      } else {
        submitButton.disabled = true;
        submitButton.textContent = cartVars.texts.outOfStock;
        submitButton.classList.add("out-of-stock");
        if (notifyStockButton) {
          notifyStockButton.classList.remove("hide");
          notifyStockButton.dataset.variationId =
            matchingVariation.variation_id;
        }
      }
      submitButton.classList.add("variation-selected");
    } else {
      variationIdInput.value = "";
      form.querySelectorAll('input[name^="attribute_"]').forEach((input) => {
        input.remove();
      });
      if (originalPrice) priceElement.innerHTML = originalPrice;
      const mobilePriceElement = document.querySelector(
        ".mobile-info-strip .product-price"
      );
      if (mobilePriceElement && originalPrice) {
        mobilePriceElement.innerHTML = originalPrice;
      }
      if (quantityInput.dataset.originalMax)
        quantityInput.max = quantityInput.dataset.originalMax;
      submitButton.disabled = true;
      submitButton.textContent = cartVars.texts.selectVariation;
      submitButton.classList.remove("variation-selected");
      submitButton.classList.remove("out-of-stock");
      if (notifyStockButton) {
        notifyStockButton.classList.add("hide");
        notifyStockButton.dataset.variationId = "";
      }
    }
  };

  attributeTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const tabGroup = tab.closest(".attribute-tabs");
      tabGroup.querySelectorAll(".attribute-tab").forEach((t) => {
        t.classList.remove("active");
      });
      tab.classList.add("active");
      updateVariationState();
    });
  });

  window.setTimeout(() => {
    const anyTabActive = Array.from(attributeTabs).some((tab) =>
      tab.classList.contains("active")
    );
    if (attributeTabs.length > 0 && !anyTabActive) {
      if (submitButton) {
        submitButton.textContent = cartVars.texts.selectVariation;
        submitButton.disabled = true;
      }
      if (notifyStockButton) {
        // Also hide notify button initially if no variation selected
        notifyStockButton.classList.add("hide");
      }
    }
    updateVariationState(); // This will correctly set the initial state of the notify button too
  }, 100);
}
